import React, { useState, useRef, useEffect } from "react";
import "./musicPlayer.css";

import {
  RiHeart2Fill,
  RiMicFill,
  RiDatabase2Fill,
  RiSpeakerFill,
  RiVolumeDownLine,
  RiPlayMiniFill,
  RiPauseMiniLine,
  RiVolumeUpLine,
  RiVolumeMuteLine,
} from "react-icons/ri";
import {
  MdShuffle,
  MdOutlineRepeat,
  MdSkipPrevious,
  MdSkipNext,
} from "react-icons/md";
import { connect } from "react-redux";
import { changePlayPause, changeTrack } from "../../actions";
import { Link } from "react-router-dom";
function MusicPlayer(props) {
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [currentVolume, setCurrentVolume] = useState(50);
  const audioPlayer = useRef();
  const progressBar = useRef();
  const animationRef = useRef();

  useEffect(() => {
    const seconds = Math.floor(audioPlayer.current.duration);
    setDuration(seconds);
    progressBar.current.max = seconds;
    audioPlayer.current.volume = currentVolume / 100;
    togglePlayPause();
    !props.isPlaying
      ? (document.title =
          props.songData.title.length < 25
            ? props.songData.title.substring(0, 30) +
              " ( From " +
              props.songData.singer +
              ")"
            : props.songData.title.substring(0, 30))
      : (document.title = "Spotify - Web Player");
  }, [
    audioPlayer?.current?.loadedmetadata,
    audioPlayer?.current?.readyState,
    currentVolume,
    props.isPlaying,
  ]);

  useEffect(() => {
    togglePlayPause();
  }, [props.isPlaying]);

  const [heart, setHeart] = useState(false);
  const [shuffeld, setShuffeld] = useState(false);
  const [random, setRandom] = useState(false);

  const togglePlayPause = () => {
    const previous = !props.isPlaying;
    // setIsPlaying(!previous);

    if (previous) {
      audioPlayer.current.play();
      animationRef.current = requestAnimationFrame(whilePlaying);
    } else {
      audioPlayer.current.pause();
      cancelAnimationFrame(animationRef.current);
    }
  };

  const calculateTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const returnedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    return `${returnedMinutes}:${returnedSeconds}`;
  };

  const whilePlaying = () => {
    progressBar.current.value = audioPlayer.current.currentTime;
    changePlayerCurrentTime();
    animationRef.current = requestAnimationFrame(whilePlaying);
  };

  const changeRange = () => {
    audioPlayer.current.currentTime = progressBar.current.value;
    changePlayerCurrentTime();
  };

  const changePlayerCurrentTime = () => {
    progressBar.current.style.setProperty(
      "--seek-before-width",
      `${(progressBar.current.value / duration) * 100}%`
    );
    setCurrentTime(progressBar.current.value);
  };

  // window.addEventListener("keydown", function (event) {
  //   event.preventDefault();
  //   if (event.key !== undefined && event.keyCode == 32) {
  //     props.changePlayPause(!props.isPlaying);
  //   }
  // });

  return (
    <>
      <audio ref={audioPlayer} src={props.songData.song}></audio>
      <div className="fixed bottom-0 left-0 right-0 bg-[#131313f2] h-24 z-10 flex items-center pl-6 pr-6 justify-between">
        <Link
          to={"/album/" + props.songData._id}
          className="flex items-center cursor-pointer"
        >
          <div
            style={{
              backgroundImage: `url(${props.songData.thumbnail})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              borderRadius: 4,
            }}
            className="w-14 h-14 rounded-md bg-white"
          ></div>
          <div className="ml-4 w-32">
            <h6 className="text-white text-sm">
              {props.songData.title.substring(0, 16)}
            </h6>
            <p className="text-white text-sm opacity-50">
              {props.songData.singer.substring(0, 16)}
            </p>
          </div>
          <RiHeart2Fill
            onClick={() => setHeart(!heart)}
            className={`text-white text-xl ml-4 ${
              heart ? "opacity-100" : "opacity-30"
            } opacity-30  transition-all cursor-pointer ease-in duration-200`}
          />
        </Link>
        <div style={{ width: "40%" }} className="flex flex-col  items-center">
          <div className="flex items-center mb-2">
            <MdShuffle
              onClick={() => setShuffeld(!shuffeld)}
              className={`text-white text-3xl ml-4 ${
                shuffeld ? "opacity-100" : "opacity-30"
              } opacity-30  transition-all cursor-pointer ease-in duration-200`}
            />
            <MdSkipPrevious className="text-white text-3xl ml-4 opacity-30 hover:opacity-100 transition-all  cursor-not-allowed ease-in duration-200" />
            <div onClick={() => props.changePlayPause(!props.isPlaying)}>
              {props.isPlaying ? (
                <RiPlayMiniFill
                  onClick={togglePlayPause}
                  className="text-black text-4xl p-2 ml-4 bg-white rounded-full  box-border opacity-80 hover:opacity-100 transition-all ease-in-out duration-200"
                />
              ) : (
                <RiPauseMiniLine
                  onClick={togglePlayPause}
                  className="text-black text-4xl p-2 ml-4 bg-white rounded-full  box-border opacity-80 hover:opacity-100 transition-all ease-in-out duration-200"
                />
              )}
            </div>
            <MdSkipNext className="text-white text-3xl ml-4 opacity-30 hover:opacity-100 transition-all  cursor-not-allowed ease-in duration-200" />
            <MdOutlineRepeat
              onClick={() => setRandom(!random)}
              className={`text-white text-3xl ml-4 ${
                random ? "opacity-100" : "opacity-30"
              } opacity-30  transition-all cursor-pointer ease-in duration-200`}
            />
          </div>
          <div
            style={{ width: "100%" }}
            className="flex items-center justify-center"
          >
            <p
              className="text-white text-[12px] opacity-90"
              style={{ width: "6%" }}
            >
              {calculateTime(currentTime)}
            </p>
            <input
              onChange={changeRange}
              ref={progressBar}
              className="progressBar"
              defaultValue={0}
              type="range"
            />
            <p className="text-white text-[12px] ml-2 opacity-90 ">
              {duration != NaN ? calculateTime(duration) : null}
            </p>
          </div>
        </div>
        <div className="flex mt-4 items-center">
          <RiMicFill className="text-white text-xl ml-4 opacity-30 hover:opacity-100 transition-all cursor-pointer ease-in duration-200" />
          <RiDatabase2Fill className="text-white text-xl ml-4 opacity-30 hover:opacity-100 transition-all cursor-pointer ease-in duration-200" />
          <RiSpeakerFill className="text-white text-xl ml-4 opacity-30 hover:opacity-100 transition-all cursor-pointer ease-in duration-200" />
          <div className="flex items-center opacity-60 hover:opacity-100 transition-all  ease-in duration-200">
            {currentVolume > 50 ? (
              <RiVolumeUpLine
                onClick={() => setCurrentVolume(0)}
                className="text-white text-xl ml-4  transition-all ease-in-out w-6"
              />
            ) : currentVolume == 0 ? (
              <RiVolumeMuteLine
                onClick={() => setCurrentVolume(0)}
                className="text-white text-xl ml-4 transition-all ease-in-out w-6"
              />
            ) : (
              <RiVolumeDownLine
                onClick={() => setCurrentVolume(0)}
                className="text-white text-xl ml-4 transition-all ease-in-out w-6"
              />
            )}
            <input
              type="range"
              min={0}
              max={100}
              value={currentVolume}
              onChange={(vol) => setCurrentVolume(vol.target.value)}
              style={{
                height: 4,
                backgroundColor: "red",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    songData: state.songData,
    isPlaying: state.isPlaying,
  };
};

export default connect(mapStateToProps, { changeTrack, changePlayPause })(
  MusicPlayer
);
